import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(0, 3),
    width: '100%',
    height: '100%',
    borderRadius: 0,
    overflow: 'hidden',
    boxShadow: 'none',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'white',
  },
  t: {},
}));

const TablePageContainer = ({ children }) => {
  const classes = useStyles();
  return <div className={classes.paper}>
    {children}
  </div>;
};

export default TablePageContainer;
